var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5 py-2"},[_c('div',{staticClass:"text-xs font-normal leading-snug uppercase",class:{ 'tracking-wider': _vm.isCustomFont }},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',{staticClass:"font-medium",class:{
      'text-base tracking-widest': _vm.isCustomFont,
      'text-sm leading-6': !_vm.isCustomFont,
    }},[_vm._v(" "+_vm._s(_vm.item.address)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }